/*jshint esversion:6 */
import request from "./request";
import URLS from "../configurations/urls";
import Api from "./Api";

class ReportsApi extends Api {
  static getReports(params) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += URLS.REPORTS;
    options.params = params;
    return request.get(options);
  }

  static getReport(params, id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.REPORTS}/${id}`;
    options.params = params;
    return request.get(options);
  }

  static downloadReport(filename) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.REPORTS}/files/${filename}`;
    return request.get(options);
  }

  static retryReportGeneration(reportType, id) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.REPORT(reportType)}/${id}`;
    options.body = {};
    return request.post(options);
  }

  static generateReport(params, reportType) {
    let options = Object.assign({}, Api.HTTP_OPTIONS);
    options.url += `${URLS.REPORT(reportType)}`;
    options.params = params;
    return request.post(options);
  }
}

export default ReportsApi;



// WEBPACK FOOTER //
// ./src/api/ReportsApi.js